<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>创建数据权限</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/datarights')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <tz-form
        width="80px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
      ></tz-form>
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { brequest } from '@/utils/brequest'
import { DATA_RIGHT_TYPE } from '@/utils/params'

export default {
  methods: {
    async submitFn(formData) {
      if (this.submited) return
      this.$loading({
        text: '数据权限添加中'
      })
      formData.rightText = formData.rightText || '-'
      let ret = await brequest({
        url: '/back/user/addUserDataRight',
        data: formData
      })
      this.$loading().close()
      if (ret.id) {
        this.submited = true
        this.$message({
          message: '数据权限添加成功',
          type: 'success'
        })
        this.$router.go(-1)
      }
    },
    async queryAllUserInfo() {
      let ret = await brequest({
        url: '/back/user/queryAllUserInfo'
      })
      this.formConfig.find((rec) => rec.field === 'userId').payload = ret.map(
        (rec) => {
          return {
            value: rec.id,
            label: rec.loginName
          }
        }
      )
    }
  },
  mounted() {
    this.queryAllUserInfo()
  },
  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '用户账号',
          field: 'userId',
          type: 'select',
          filterable: true,
          payload: [],
          rules: [{ required: true, message: '用户账号必填', trigger: 'blur' }]
        },
        {
          label: '权限类型',
          field: 'rightType',
          type: 'select',
          payload: DATA_RIGHT_TYPE,
          rules: [
            { required: true, message: '数据权限类型必填', trigger: 'blur' }
          ]
        },
        {
          label: '权限内容',
          field: 'rightText',
          type: 'text',
          rules: [{ required: false, trigger: 'blur' }]
        }
      ],
      formBtns: [
        {
          content: '创建',
          width: '185px',
          type: 'primary'
        },
        {
          content: '重置',
          width: '185px',
          type: ''
        }
      ]
    }
  }
}
</script>

<style></style>
